import Loader from '../../../../components/Loader'

export const CircleLoader = (
  <Loader width={76} height={76}>
    <circle cx="50%" cy="50%" r="32" />
  </Loader>
)

export const NameLoader = [
  <Loader width={'100%'} height={20} key={1}>
    <rect x="0" y="0" rx="3" ry="3" width={'100%'} height="18" />
  </Loader>,
  <Loader width={'100%'} height={20} key={2}>
    <rect x="0" y="0" rx="3" ry="3" width={'100%'} height="18" />
  </Loader>,
  <Loader width={'100%'} height={20} key={3}>
    <rect x="0" y="0" rx="3" ry="3" width={'100%'} height="18" />
  </Loader>,
]

export const TotalLessonLoader = [
  <Loader width={150} height={20} key={1}>
    <rect x="0" y="0" rx="3" ry="3" width={'100%'} height="16" />
  </Loader>,
]

export const LessonCardLoader = [
  <Loader width={'100%'} height={66} key={1} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
  <Loader width={'100%'} height={66} key={2} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
  <Loader width={'100%'} height={66} key={3} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
  <Loader width={'100%'} height={66} key={4} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
  <Loader width={'100%'} height={66} key={5} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
  <Loader width={'100%'} height={66} key={6} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
  <Loader width={'100%'} height={66} key={7} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
  <Loader width={'100%'} height={66} key={8} style={{ flexShrink: 0 }}>
    <circle cx="35px" cy="18px" r="9px" />
    <rect x="52px" y="10px" rx="3" ry="3" width={130} height="16" />
    <rect x="52px" y="36px" rx="3" ry="3" width={80} height="14" />
    <rect x="calc(100% - 34px)" y="10px" rx="3" ry="3" width={20} height={20} />
  </Loader>,
]
